// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__14kKR","rootSmall":"AddTileButton_rootSmall__3hMPa"};